import React, { useEffect } from 'react';
import classNames from 'classnames';
import Modal from 'react-modal';
import { usePrevious } from '../../hooks';
import { ErrorMessage } from './Message';
import LoadingSpinner from './LoadingSpinner';

export type TModalConfirmationWithErrorAndLoader = {
    children: React.ReactNode;
    className: string;
    errorMessage: string;
    handleCancel: () => void;
    handleContinue: () => void;
    isError: boolean;
    isInProgress: boolean;
    setIsInProgress: (value: boolean) => void;
    isOpen: boolean;
    title: string;
    continueEnabled?: boolean;
    continueButtonText?: string;
};

export function ModalConfirmationWithErrorAndLoader({
    children,
    className,
    errorMessage,
    handleCancel,
    handleContinue,
    isError,
    isInProgress,
    setIsInProgress,
    isOpen,
    title,
    continueEnabled = true,
    continueButtonText = 'OK',
}: TModalConfirmationWithErrorAndLoader) {
    const prevIsOpen = usePrevious(isOpen);

    useEffect(() => {
        // Prevents from unintentional confirmation when modal is opened (e.g. by double-click)
        if (isOpen && !prevIsOpen) {
            setIsInProgress(true);
            setTimeout(() => {
                setIsInProgress(false);
            }, 250);
        }
    }, [isOpen]);

    return (
        <Modal
            className={classNames(
                'modal',
                'ModalConfirmationWithErrorAndLoader',
                className,
            )}
            contentLabel={title}
            onRequestClose={handleCancel}
            ariaHideApp={false}
            isOpen={isOpen}
        >
            <div className="message">{children}</div>
            {isError && <ErrorMessage message={errorMessage} />}
            <button
                className="continue btn--round-big"
                onClick={handleContinue}
                disabled={!continueEnabled || isInProgress}
                type="button"
            >
                {isInProgress ? (
                    <LoadingSpinner
                        className="spinner"
                        backgroundColor="white"
                    />
                ) : (
                    continueButtonText
                )}
            </button>
            {!isInProgress && (
                <button className="back" onClick={handleCancel} type="button">
                    CANCEL
                </button>
            )}
        </Modal>
    );
}
